<template>
  <div class="expense">
    <div>
      <div class="row">
        <div class="col name">
          <span>{{expense.name}}</span>
        </div>

        <div class="col-4 value" v-bind:class="{ above: expense.value && sumChild > expense.value }">
          <span v-if="childs">{{sumChild | currency}}<span v-if="expense.value"> z </span></span>{{expense.value | currency}}
        </div>
      </div>

      <div class="row description" v-if="expense.description">{{expense.description}}</div>
      <div v-if="expense.months && expense.months.length">{{expense.months | months}}</div>
    </div>

    <div class="checkbox" v-if="editable && expense.value">
      <MoneyCheckbox v-model="expense.done" @input="$forceUpdate()"></MoneyCheckbox>
    </div>
  </div>
</template>

<script>
export default {
  props: ["expense", "editable", "childs"],
  computed: {
    sumChild() {
      return this.childs && this.childs.reduce((acc, curr) => {
        acc = acc + parseFloat(curr.value);
        return acc;
      }, 0);
    }
  },
};
</script>

<style lang="scss" scoped>
.expense {
  display: flex;
  justify-content: center;
  align-items: center;

  & > *:not(.checkbox) {
    flex: 1;
  }

  .name {
    font-weight: 400;
  }

  .value {
    font-weight: 1;
    text-align: right;
  }

  .checkbox {
    padding: 0px 15px;
  }

  .description {
    color: gray;
    font-size: 0.8rem;
  }

  .above {
    color: red;
  }
}
</style>